export default __webpack_public_path__ + "static/award-7df4bd312ab5d78bd8cce3929a435c27.jpg";